import Bezel from "../images/customisation-option-icons/bezel.svg";
import Case from "../images/customisation-option-icons/case.svg";
import Dial from "../images/customisation-option-icons/dial.svg";
import Engraving from "../images/customisation-option-icons/engraving.svg";
import Hands from "../images/customisation-option-icons/hands.svg";
import Initials from "../images/customisation-option-icons/initials.svg";
import SecondsHand from "../images/customisation-option-icons/sec_hand.svg";
import Stamp from "../images/customisation-option-icons/stamp.svg";
import Strap from "../images/customisation-option-icons/strap.svg";
import TwoFourHourHand from "../images/customisation-option-icons/two_four_hour_hand.svg";
import Tick from "../images/button-icons/tick.svg";
import Restart from "../images/button-icons/restart.svg";
import Cart from "../images/button-icons/cart.svg";
import Arrow from "../images/arrow.svg";
import ExitArrow from "../images/exit_arrow.svg";
import NavigationArrow from "../images/navigation_arrow.svg";
import BamfordLogo from "../images/bamford-london-logo.png";

const assets = {
  Bezel,
  Case,
  Dial,
  Engraving,
  Hands,
  Initials,
  SecondsHand,
  Stamp,
  Strap,
  TwoFourHourHand,
  Tick,
  Restart,
  Cart,
  Arrow,
  ExitArrow,
  NavigationArrow,
  BamfordLogo,
};

export const getAsset = (name) => assets[name];
